import NotificationService from "@/services/notification.service.js";

export default class NotificationUsecase {
  constructor () {
    this.notificationService = new NotificationService();
  }

  async getNotifications () {
    const res = await this.notificationService.list();
    return res;
  }
  async createNotification (options) {
    const res = await this.notificationService.create(options);
    return res;
  }
  async readNotification (option) {
    const res = await this.notificationService.read(option);
    return res;
  }
  async getAddedNotificationSubscriber () {
    const res = await this.notificationService.getSubscriber();
    return res;
  }
}
